<template>
  <div class="outpage">
    <div class="w100 sta1 flex-cc">
      <div class="flex-cc">
        <img class="mlogo1" src="../assets/logo.png" alt="">
        <div class="mlogo2">
          <div class="mlp1">网络空间内生安全知识平台</div>
          <div class="mlp2">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
        </div>
      </div>
      <div class="sta3">争鸣论坛</div>
    </div>
    <div class="w100 stamiddle" ref="scrollContainer">
      <div v-show="detailnum == 1" class="stam1">
        <div class="flex-cc mt30 mt20">
          <div v-for="(item,index) in leilist" class="flex-hl fll1 mt10"><span @click="changelei(item)" class="fll3"
                                                                                :class="[item.id == dingid?'leihot':'']">{{
              item.name
            }}</span><span
              v-if="index != (leilist.length-1)" class="fll2">|</span></div>
        </div>
        <div class="w100">
          <el-form :inline="true" :model="sform" class="demo-form-inline sformin mt20">
<!--            <el-form-item label="" class="w200">-->
<!--              <el-select class="" v-model="sform.typeId" placeholder="请选择论坛主题">-->
<!--                <el-option-->
<!--                    v-for="item in leilist"-->
<!--                    :key="item.id"-->
<!--                    :label="item.name"-->
<!--                    :value="item.id">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="" class="w200 wnew200">
              <el-input v-model="sform.input" placeholder="搜索内容"></el-input>
            </el-form-item>
            <el-form-item label="发布时间" class="w270 wnew270">
              <el-date-picker
                  v-model="sform.time"
                  popper-append-to-body
                  type="daterange"
                  ref="datePicker"
                  :placement.sync="pickerPlacement"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发布人" class="w200 wnew200">
              <el-input v-model="sform.user" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="flex-hl">
                <div @click="subsear" class="searbtn1 cur"><i class="el-icon-search"></i></div>
                <div @click="resetsear" class="searbtn2 cur">重置</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="flex-hl">
          <div @click="subbuopen" class="forum1 cur">发帖</div>
        </div>
        <div class="forum2 mt10">
<!--          @row-click="handleRowClick"-->
          <el-table
              :data="datalist"
              class="listt1"
              style="width: 100%"
              :default-sort="{prop: 'date', order: 'descending'}"
          >
            <el-table-column
                prop="type"
                align="center"
                label="论坛主题">
            </el-table-column>
            <el-table-column
                prop="date"
                label="标题"
                align="center"
                width="500">
              <template slot-scope="scope">
                <el-tooltip class="w100 overflow" effect="dark" :content="scope.row.title" placement="top-start">
                  <el-button class="noborder w100 textcenter" style="font-size: 16PX !important;" @click="handleRowClick(scope.row)">
                    {{ scope.row.title }}
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
                prop="user"
                align="center"
                label="发布人">
            </el-table-column>
            <el-table-column
                align="center"
                prop="gmtCreate"
                width="160"
                label="发布时间"
                sortable>
            </el-table-column>
            <el-table-column
                align="center"
                prop="count"
                width="120"
                label="回复数量"
                sortable>
            </el-table-column>
            <el-table-column
                align="center"
                prop="latestTime"
                width="170"
                label="最近回复"
                sortable>
            </el-table-column>
<!--            <el-table-column-->
<!--                prop="date"-->
<!--                label="操作"-->
<!--                width="160"-->
<!--                align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <div class="w100 flex-cc">-->
<!--                  <div class="cbtn1" @click="editinfo(scope.row)">-->
<!--                    编辑-->
<!--                  </div>-->
<!--                  <div class="cbtn2" @click="deleteinfo(scope.row)">-->
<!--                    删除-->
<!--                  </div>-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>

          <div class="w100 mt20 flex-cc">
            <el-pagination
                background
                v-if="datalist.length > 0"
                layout="prev, pager, next"
                :current-page.sync="pageObj.currentPage"
                :page-size="pageObj.pageSize"
                :total="pageObj.total"
                @current-change="pageChange">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-show="detailnum == 2" class="stam1">
        <div class="w100 sta6"><span class="cur" @click="tohome">首页></span><span class="cur" @click="toone">争鸣论坛></span><span>详情</span>
        </div>
        <div class="sta4 w100 mt20">
<!--          <div class="wenxiang over1">{{ articleinfo.title }}</div>-->
          <el-tooltip class="w100 overflow" effect="dark" :content="articleinfo.title" placement="bottom">
            <el-button class="titleborder w100">
              {{ articleinfo.title }}
            </el-button>
          </el-tooltip>
          <div class="wenxiang2 flex-cc">
            <div>{{ articleinfo.user }}</div>
            <div class="wms1">|</div>
            <div>{{ articleinfo.gmtCreate }}</div>
            <div class="wms1">|</div>
            <div class="flex-cc">
              <img class="wxim2" src="../assets/img/huifu.png" alt="">
              <span>{{ articleinfo.count }}</span>
            </div>
            <div class="wms1">|</div>
            <div class="flex-cc">
              <img class="wxim1" src="../assets/img/liulan.png" alt="">
              <span>{{ articleinfo.views }}</span>
            </div>
          </div>
          <div class="w100 pwhite" style="color: white !important;" v-html="articleinfo.content">

          </div>
        </div>
        <div class="sta5 w100 mt20">
          <div><span class="colorql">评论</span><span class="ml5">{{ pinglist.length }}</span></div>
          <div class="flex-hl fbox mt20">
            <img class="mimg1" :src="userinfo.photo?userinfo.photo:require('../assets/img/morentouxiang.png')" alt="">
            <div class="flex-1">
              <el-input
                  type="textarea"
                  resize="none"
                  :rows="3"
                  id="textInput"
                  placeholder="请输入内容"
                  v-model="contentping">
              </el-input>
              <div class="w100 flex-hls mt10 porelative">
                <div class="flex-hlc cur " @click="togglePicker">
                  <img class="biaoimg1" src="../assets/img/biaoqing.png" alt="">
                  <span class="biaoimg2">表情</span>

                </div>
                <VEmojiPicker
                    class="z999"
                    :style="{ width: '300px', height: '200px', position: 'absolute',left: '0px',top: '40px', }"
                    v-show="showPicker"
                    @select="insertEmojiAtCursor"
                />
                <div class="fb1 cur" @click="fabu">发布评论</div>
              </div>
            </div>
          </div>
<!--          评论列表-->
          <div class="flex-hl fbox mt20" :id="item.id" v-for="(item,idx) in pinglist">
            <!--            外层一级回复-->
            <img class="mimg1" :src="item.photo?item.photo:require('../assets/img/morentouxiang.png')" alt="">
            <div class="flex-1">
              <div class="texth1">{{ item.user }}</div>
              <el-input
                  type="textarea"
                  autosize
                  disabled
                  resize="none"
                  class="text-nocss"
                  placeholder=""
                  v-model="item.content">
              </el-input>
              <div class="w100 mt10">
                <span class="texth2">{{ item.gmtCreate }}</span>
                <span class="texth3 cur" @click="replyx(item)">回复</span>
              </div>
              <!--              内层多级回复 默认展示三条-->
              <div class="flex-hl fbox mt20 lastborder" :id="itemtwo.id" v-if="item.zhe?indextwo<3:true" v-for="(itemtwo,indextwo) in item.replyList">
                <img class="mimg2" :src="itemtwo.photo?itemtwo.photo:require('../assets/img/morentouxiang.png')" alt="">
                <div class="flex-1">
                  <div class="texth1"><span>{{ itemtwo.user }}</span><span v-if="itemtwo.toUser" class="colorwhite huimlr">回复</span><span>{{ itemtwo.toUser }}</span>
                  </div>
                  <el-input
                      type="textarea"
                      autosize
                      disabled
                      resize="none"
                      class="text-nocss"
                      placeholder=""
                      v-model="itemtwo.content">
                  </el-input>
                  <div class="w100 mt10">
                    <span class="texth2">{{ itemtwo.gmtCreate }}</span>
                    <span class="texth3 cur" @click="replyx(itemtwo)">回复</span>
                    <span class="texth3 cur" @click="openmore(idx)" v-if="item.replyList.length > 3 && item.zhe && indextwo == 2">打开更多</span>
                    <span class="texth3 cur" @click="closemore(idx)" v-if="item.replyList.length > 3 && !item.zhe && indextwo == (item.replyList.length - 1)">收起更多</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%;height: 40px;"></div>
      </div>
      <div v-show="detailnum == 3" class="stam1">
        <div class="w100 sta6"><span>首页></span><span class="cur" @click="detailnum = 1">争鸣论坛></span><span>发布</span>
        </div>
        <div class="sta4 w100 mt20">
          <div class="w100 flex-hlc">
            <div class="but1">标题</div>
            <el-input class="but2" v-model="title" placeholder="请输入"></el-input>
          </div>
          <div class="w100 flex-hlc mt20">
            <div class="but1">论坛主题</div>
            <el-select class="but2" v-model="leiid" placeholder="请选择">
              <el-option
                  v-for="item in leilist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="w100 flex-hlc mt20">
            <div class="but1">内容</div>
            <Editor class="but3" :value="richText" @input="neiclick"></Editor>
          </div>
          <div class="w100 flex-cc mt20">
            <div @click="nobu" class="quxiaohui mr20 f15">取消</div>
            <div @click="subbu()" class="querenlan f15">确认发布</div>
          </div>
        </div>

      </div>
      <div class="bottomd flex-cc">
        <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>
        <span class="shus"></span>
        <img src="../assets/guohui.png" class="jinghui" alt="">
        <span>苏CP备14016373号-4</span>
      </div>
    </div>
    <div class="dingping" v-show="showMask">
      <div class="dingpnei">
        <div class="huit1">回复</div>
        <div class="flex-hl fbox">
          <el-input
              type="textarea"
              resize="none"
              :rows="3"
              id="textInputhui"
              placeholder="请输入内容"
              v-model="contenthui">
          </el-input>
          <div class="w100 flex-hls mt10 porelative">
            <div class="flex-hlc cur " @click="togglePickerhui">
              <img class="biaoimg1" src="../assets/img/biaoqing.png" alt="">
              <span class="biaoimg2">表情</span>
            </div>
            <VEmojiPicker
                class="z999"
                :style="{ width: '300px', height: '200px', position: 'absolute',left: '0px',top: '40px', }"
                v-show="showPickerhui"
                @select="insertEmojiAtCursorhui"
            />
          </div>
        </div>
        <div class="w100 flex-cc">
          <div @click="noreplay" class="quxiaohui mr20">取消</div>
          <div @click="subreplay()" class="querenlan">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@/components/Richtext';

export default {
  name: 'fornum',
  components: {
    Editor
  },
  props: {
    colorindex: [String, Object, Array, Number],
    pushnum: [String, Object, Array, Number],
  },
  data() {
    return {
      userinfo:JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null,
      contentping: '',
      content: '😌撒撒打发撒打发手打阿发送达啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊阿发法撒旦的点点滴滴滴答滴答',
      contenthui: '',
      cursorPosition: 0,//评论当前光标位置
      cursorPositionhui: 0,//回复当前光标位置
      isComposing: false, // 中文输入法状态标记
      showPicker: false,
      showPickerhui: false,
      replaylook: false,
      pickerPlacement: 'bottom-start',
      pageObj: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      sform: {
        input: '',
        time: '',
        user: '',
        // typeId: '',
      },
      detailnum: 1,//1是列表2是详情3是发布
      articleinfo: '',
      nowinfo:{},//当前点击的一条帖子
      nowflow: '',//当前点击的信息要回复
      pinglist:[],//评论的列表
      leilist:[],
      dingid:'99',
      leiid:'',
      pingid:'',//评论的列表
      showMask: false,
      subinfo: false,
      // 保存原始滚动位置
      scrollTop: 0,
      infoid:'',//帖子id
      title: '',
      richText: '',
      datalist:[],
      zhelist:true,//是否遮住超过三条的回复
    }
  },
  watch: {
    // 监听遮罩层显示/隐藏，控制滚动锁定
    showMask(newVal) {
      if (newVal) {
        // 显示遮罩时，禁止背景滚动
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        document.body.style.position = 'fixed'
        document.body.style.top = `-${this.scrollTop}px`
        document.body.style.width = '100%'
      } else {
        // 隐藏遮罩时，恢复滚动
        document.body.style.position = ''
        document.body.style.top = ''
        // 恢复到原来的滚动位置
        window.scrollTo(0, this.scrollTop)
      }
    },
    pushnum(newVal) {
      this.getdata();
      this.detailnum = 1;
    },
    $route(to, from) {
      // console.log('内部监听$route',to, from)
    },
  },
  // 11
  mounted() {
    if(this.$route.query.tieid){
      if(this.$route.query.pingid){//点击文章进来是没有评论id的
        this.zhelist=false;
        this.pingid = this.$route.query.pingid;
      }
      this.nowinfo.id = this.$route.query.tieid;
      this.getping();//获取评论
      if(this.$route.query.edit){//编辑
        this.editinfo()//和获取详情走的是同一个接口，这里需要回显
      }else{
        this.getdetail();//获取详情
      }
    }
    this.getdata();
    this.getlei();
    // console.log('pushnum内部',this.pushnum)
      this.$nextTick(() => {
        this.jianhui();//监听回复字数
        this.jianping();//监听评论字数
      })
  },
  // 22
  methods: {
    changelei(val) {
      this.dingid = val.id;
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata();
    },
    getlei() {
      let data = {}
      this.$http({
        url: "post/type/list",
        method: "POST",
        data: data
      }).then(res => {
        let data=res.data;
        data.unshift({name:'全部',id:'99'})
        this.leilist = data;
      });
    },

    retryScroll(id, maxRetries, interval) {
      let retries = 0;
      const check = () => {
        const target = document.getElementById(id);
        let topnum = target.offsetTop;
        console.log('offsetTop',target.offsetTop,target)
        if (target && topnum > 0) {
            target.scrollIntoView({ behavior: 'smooth' });
          return;
        }
        retries++;
        console.log('retries',retries)
        if (retries < maxRetries) {
          setTimeout(check, interval); // 未找到，继续重试
        } else {
          console.log(`超过${maxRetries}次重试，未找到元素`);
        }
      };
      check(); // 立即开始第一次检查
    },
    tohome(){
      this.$router.push({
        path: '/',
      })
    },
    toone(){
      this.$router.push({
        path: '/forum',
      })
    },
    openmore(idx){
      this.pinglist[idx].zhe = false;
    },
    closemore(idx){
      this.pinglist[idx].zhe = true;
    },
    getdata(){
      let data=JSON.parse(JSON.stringify(this.sform));
      data.typeId=this.dingid == '99'?'':this.dingid;
      data.pageNumber=this.pageObj.currentPage;
      data.pageSize=this.pageObj.pageSize;
      data.type = 0;//0全部(默认) 1我的
      data.time=data.time&& data.time.length == 2?(this.$timeDay(data.time[0])+'~'+this.$timeDay(data.time[1])):'';
      this.$http({
        url: "post/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.scrollToBottom()
        // console.log('res2',res.data)
        this.pageObj.total = res.data.total;
        this.datalist = res.data.records;
      });
    },
    scrollToBottom() {
      // 获取目标div的DOM元素
      const container = this.$refs.scrollContainer;
      if (container) {
        // 设置滚动条位置到最底部
        container.scrollTop = 0;
      }
      // 如果上面无效，尝试下面
      setTimeout(() => {
        container.scrollTo({ top: 0, behavior: 'auto' });
      }, 10);
    },
    subbuopen() {
      this.title = '';
      this.richText = '';
      this.leiid = '';
      this.infoid = '';
      this.detailnum = 3;
    },
    handleRowClick(row, column, event) {
      this.nowinfo = row;
      this.$router.push({
        path: '/forum',
        query:{
          tieid:row.id,//看详情需要用这种方式，防止从别的地方跳过来的参数
        }
      })
      // this.getping();//获取评论
      // this.getdetail();//获取详情
    },

    getdetail(){
      let data={
        postId:this.nowinfo.id
      }
      this.$http({
        url: "post/detail",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.infoid = '';
        if(res.data.content){
          res.data.content = this.replacePStylesEnhanced(res.data.content);
        }
        // console.log('res2',res.data)
        this.articleinfo = res.data;
        this.detailnum = 2;
      });
    },
    replacePStylesEnhanced(htmlString) {
      // 创建临时 DOM 元素来解析 HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      // 获取所有的 p 元素
      const pe1 = tempDiv.querySelectorAll('p');
      const pe8 = tempDiv.querySelectorAll('span');
      // 遍历每个 p 元素并修改样式
      pe1.forEach(p => {
        p.style.fontSize = '18PX';
        p.style.lineHeight = '2EM';
        p.style.backgroundColor = '';
      });
      pe8.forEach(p => {
        p.style.fontSize = '18PX';
        p.style.lineHeight = '2EM';
        p.style.backgroundColor = '';
      });

      // 返回修改后的 HTML 字符串
      return tempDiv.innerHTML;
    },
    editinfo(){
      let data={
        postId:this.nowinfo.id
      }
      this.$http({
        url: "post/detail",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        console.log('详情',res.data)
        this.infoid = res.data.id;
        this.title = res.data.title;
        this.richText = res.data.content;
        this.detailnum = 3;
      });
    },
    // 评论列表
    getping(){
      let data={
        postId:this.nowinfo.id
      }
      this.$http({
        url: "comment/list",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        if(this.zhelist){//其余逻辑不动，展开和回复只靠这里控制就行
          res.data.forEach(item => {
            item.zhe=true
          })
        }else{
          res.data.forEach(item => {
            item.zhe=false
          })
        }

        this.pinglist = res.data;
          this.$nextTick(()=>{
            if(this.pingid){
              // this.scrollToTarget(this.pingid)
              this.retryScroll(this.pingid,10,300)
            }
          })


        // console.log('this.pinglist',this.pinglist);
      });
    },
    nobu() {
      this.detailnum = 1;
    },
    subbu() {
      if(!this.title){
        this.$message({
          message: '标题不能为空！',
          type: 'warning'
        });
        return false
      }
      // if(this.subinfo){
      //   return
      // }
      // this.subinfo = true
      let data={
        title:this.title,
        content:this.richText,
        typeId:this.leiid,
        id:this.infoid?this.infoid:'',
      }
      this.$http({
        url: "post/add",
        method: "POST",
        data: data
      }).then(res => {
        this.$message({
          message: '发布成功等待后台审核！',
          type: 'success'
        });
        this.detailnum = 1;
        this.getdata();
        // this.subinfo = false
        this.$router.push({
          path: '/forum',
        })
      }).catch(err=>{
        // this.subinfo = false
      })
    },
    // 富文本
    neiclick(val) {
      // console.log('富文本', val)
      this.richText = val;
    },
    // 取消回复
    noreplay() {
      this.showMask = false;
    },
    // 确认回复
    subreplay() {
      if(!this.contenthui){
        this.$message({
          message: '回复不能为空！',
          type: 'error'
        });
        return;
      }
      let data={
        id:this.nowflow.id,
        content:this.contenthui,
      }
      this.$http({
        url: "comment/reply",
        method: "POST",
        data: data
      }).then(res => {
        this.$message({
          message: '发布成功等待后台审核！',
          type: 'success'
        });
        this.contenthui = '';
        this.showMask = false;
      });
    },
    // 回复
    replyx(val) {
      this.nowflow = val;
      // this.replaylook = true;
      this.showMask = true;
    },
    jianhui() {
      let that = this;
      // 监听回复
      // document.addEventListener('DOMContentLoaded', () => {
      //   console.log('执行了吗jianhui')
        const textarea = document.getElementById('textInputhui');
        let isComposing = false; // 中文输入法标记
        // 主计算函数
        function calculateCursorPosition() {
          if (isComposing) return;
          const cursorPos = textarea.selectionStart;
          that.cursorPositionhui = cursorPos;
          console.log('cursorPos监听回复位置', cursorPos, that.cursorPositionhui)
        }

        // 事件监听
        textarea.addEventListener('click', calculateCursorPosition);
        textarea.addEventListener('keyup', calculateCursorPosition);
        textarea.addEventListener('input', calculateCursorPosition);
        textarea.addEventListener('mouseup', calculateCursorPosition);

        // 处理中文输入法
        textarea.addEventListener('compositionstart', () => {
          isComposing = true;
        });

        textarea.addEventListener('compositionend', () => {
          isComposing = false;
          calculateCursorPosition();
        });

        // 初始化显示
        calculateCursorPosition();
      // });
    },
    jianping() {

      // 监听评价
      let that = this;
      // document.addEventListener('DOMContentLoaded', () => {
      //   console.log('执行了吗jianping')

        const textarea = document.getElementById('textInput');

        let isComposing = false; // 中文输入法标记

        // 主计算函数
        function calculateCursorPosition() {
          if (isComposing) return;
          const cursorPos = textarea.selectionStart;
          that.cursorPosition = cursorPos;
          console.log('cursorPos监听评价位置', cursorPos, that.cursorPosition)
        }

        // 事件监听
        textarea.addEventListener('click', calculateCursorPosition);
        textarea.addEventListener('keyup', calculateCursorPosition);
        textarea.addEventListener('input', calculateCursorPosition);
        textarea.addEventListener('mouseup', calculateCursorPosition);

        // 处理中文输入法
        textarea.addEventListener('compositionstart', () => {
          isComposing = true;
        });

        textarea.addEventListener('compositionend', () => {
          isComposing = false;
          calculateCursorPosition();
        });

        // 初始化显示
        calculateCursorPosition();
      // });
    },
    fabu() {
      // console.log('问你', this.content)
      if(!this.contentping){
        this.$message({
          message: '评论不能为空！',
          type: 'error'
        });
        return;
      }
      let data={
        content:this.contentping,
        postId:this.nowinfo.id
      }
      this.$http({
        url: "comment/add",
        method: "POST",
        data: data
      }).then(res => {
        this.$message({
          message: '发布成功等待后台审核！',
          type: 'success'
        });
        this.contentping = '';
      });
    },
    togglePicker() {
      this.showPicker = !this.showPicker;
    },
    togglePickerhui() {
      this.showPickerhui = !this.showPickerhui;
    },
    insertEmojiAtCursor(emoji) {
      const startPos = this.cursorPosition;
      // 分割文本并插入表情
      this.contentping =
          this.contentping.substring(0, startPos) +
          emoji.data +
          this.contentping.substring(startPos);
      this.showPicker = false;
    },
    insertEmojiAtCursorhui(emoji) {
      const startPos = this.cursorPositionhui;
      // 分割文本并插入表情
      this.contenthui =
          this.contenthui.substring(0, startPos) +
          emoji.data +
          this.contenthui.substring(startPos);
      this.showPickerhui = false;
    },
    pageChange(page) {
      console.log('page',page)
      this.pageObj.currentPage = page;
      this.getdata()
      // this.getDataList(true);
    },
    subsear() {
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata();
    },
    resetsear() {
      this.sform = Object.assign(this.sform, this.$options.data().sform);
      this.subsear();
    },
  },

}
</script>
<style lang="scss" scoped>
/deep/ {
  .el-table th.el-table__cell>.cell{
    font-size: 16PX !important;
  }
  .el-table td.el-table__cell div{
    font-size: 16PX !important;
  }
}
@media screen and (max-width: 1440px)  {
  .sformin .searbtn1{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  .sformin .searbtn2{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  /deep/ {
    .sformin .el-form-item__label{
      line-height: 50px !important;
    }
    .wnew200 .el-input__inner {
      width: 122px !important;
      height: 50px !important;
    }

    .wnew270 .el-input__inner {
      height: 50px !important;
      width: 250px !important;
    }
    .wnew270 .el-range-separator{
      line-height: 44px !important;
    }
  }
}
.titleborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: center !important;
  font-size: 30px !important;
  font-weight: bold;
  margin-bottom: 10px;
}

.titleborder:hover {
  background: none;
  color: #fff !important;
}
</style>
<style lang="scss">
.pwhite{
  p, span, div, li{
    color: white !important;
  }
}
p:has(video) {
  height: fit-content !important; /* 高度自适应内容（视频高度） */
  display: inline-block;
  margin: 10px 0; /* 可选：添加边距 */
}
.wxim1{
  width:18px;
  height: 13px;
  margin-right: 5px;
}
.wxim2{
  width:18px;
  height: 16px;
  margin-right: 5px;
}
.but1 {
  width: 10%;
  color: white;
  text-align: right;
  box-sizing: border-box;
  padding-right: 20px;
  font-size: 16px;
}

.but2 {
  width: 90% !important;
}

.but3 {
  width: 90%;
  border-radius: 8px;
  overflow: hidden;
}

.dingping {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.6);

  .dingpnei {
    width: 768px;
    height: max-content;
    border-radius: 16px;
    background: #0B3E73;
    padding: 20px;
    position: absolute;
    top: -200px;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;

    .huit1 {
      font-size: 18px;
      color: white;
      font-weight: bold;
      text-align: center;
      margin-bottom: 10px;
    }
  }

  .quxiaohui {
    height: 40px;
    line-height: 40px;
  }

  .querenlan {
    height: 40px;
    line-height: 40px;
  }
}

.tanpass1 .el-dialog__body {
  padding: 20px;
}

.lastborder:last-child {
  padding-bottom: 20px;
  border-bottom: 1px solid #1A5C9B;
}

.biaoimg1 {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  margin-right: 10px;
}

.biaoimg2 {
  font-size: 16px;
  color: #0090FF;
}

.fb1 {
  width: 120px;
  height: 40px;
  background: #0090FF;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
}

.huimlr {
  margin-left: 6px;
  margin-right: 6px;
}

.texth1 {
  font-size: 16px;
  color: #A0B8E2;
  margin-bottom: 10px;
}

.texth2 {
  font-size: 15px;
  color: #A0B8E2;
}

.texth3 {
  color: #0090FF;
  margin-left: 10px;
}

.mimg1 {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 15px;
}

.mimg2 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 15px;
}

.sta4 {
  width: 100%;
  min-height: 505px;
  box-sizing: border-box;
  padding: 40px 80px;
  border-radius: 16px;
  background: rgba(14, 62, 108, 0.5);
}

.sta5 {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 16px;
  background: rgba(14, 62, 108, 0.5);
  color: white;
}

.colorql {
  color: #A0B8E2;
}

.sta6 {
  font-size: 16px;
  color: white;
  margin: 20px 0;
}

.noborder {
  border: none !important;
  padding: 0 !important;
  font-size: 15px !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;

}

.noborder:hover {
  background: none;
  color: #0090FF !important;
}

.overflow {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
<style scoped lang="scss">
.outpage{
  height: calc(100vh - 80px);
  overflow: hidden;
}
/deep/ {
  .el-table .cell{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .but2 .el-input__inner {
    background: #0E3E6C;
    border: none !important;
    color: white;
    height: 50px;
    line-height: 50px;
  }
}

.stamiddle {
  //min-height: 760px;
  //max-height: 760px;
  //height: max-content;
  height: calc(100vh - 160px);
  min-height: calc(100vh - 160px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: inline-block !important;
    width: 2px;
    height: 2px;}
  &::-webkit-scrollbar-thumb {
    background-color: #05121D;
    border-radius: 10px;}
  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
    border-radius: 10px;}
}

.forum2 {
  background: rgba(14, 62, 108, 0.8);
  box-sizing: border-box;
  border-radius: 16px;
  padding-bottom: 40px;
  color: white;
  //min-height: 600px;
  min-height: 74vh;
  overflow: hidden;
  margin-bottom: 40px;
}

.forum1 {
  width: 100px;
  height: 40px;
  background: #0090FF;
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: white;
}

/* 关键：使用深度选择器修改表格标题样式 */
::v-deep .el-table__header {
  border-radius: 15px 15px 0 0;
  overflow: hidden;
}

::v-deep .el-table__body tr:hover > td > .cell > button {
  color: #0090FF !important;
}

::v-deep .el-table {
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

/* 标题单元格背景色和边框 */
::v-deep .el-table__header th {
  background-color: #0566B5 !important; /* 标题背景色 */
  color: white;
  border-bottom: none !important;
}

/* 表格整体圆角 */
::v-deep .el-table--border {
  border-radius: 16px;
  overflow: hidden;
  border: none !important;
}

::v-deep .el-table__body tr:hover > td {
  background-color: transparent !important; /* 覆盖默认悬停背景色 */
  color: #0090FF !important;
}

/* 核心：表格内容区域背景透明 */
/* 表格整体背景透明 */
::v-deep .el-table {
  background-color: transparent !important;
}

/* 表格内容行背景透明 */
::v-deep .el-table__body tr {
  background-color: transparent !important;
  color: white;
  //cursor: pointer;
}

/* 表格单元格背景透明 */
::v-deep .el-table__body td {
  background-color: transparent !important;
  border-color: #516D9E !important;
}

/* 展开行背景透明（如需） */
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}

::v-deep .el-table::before {
  display: none;
}

::v-deep .el-table--border::after, .el-table--group::after, .el-table::before {
  display: none;
}


/deep/ {
  .el-textarea__inner {
    background: #0A2846;
    border-color: #0694FC;
    color: white;
  }

  .el-textarea__inner:focus {
    border-color: #0694FC !important;
  }

  .el-textarea__inner:hover {
    border-color: #0694FC !important;
  }

  .sformin .el-form-item {
    margin-bottom: 10px;
  }

  .sformin .el-input__inner {
    height: 60px;
    background: rgba(6, 15, 30, 0.5);
    border-radius: 16px;
    font-size: 18px;
    border: solid 1px #0694FC;
    color: white;
  }

  .sformin .el-form-item__label {
    height: 60px;
    line-height: 60px;
    color: white;
    font-size: 18px;
  }

  .sformin .el-range-input {
    color: white;
    font-size: 18px;
    background: rgba(14, 62, 108, 0);
  }

  .sformin .el-range-separator {
    line-height: 54px;
    color: white;
  }
}

.mlogo1 {
  width: 80px;
  height: 80px;
}

.mlp1 {
  font-size: 33px;
}

.mlp2 {
  font-size: 11px;
  letter-spacing: 0 !important;
}

.searbtn1 {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  display: inline-block;
  background: #0090FF;
  border-radius: 16px;
  font-size: 24px;
  color: white;
  margin-right: 10px;
}

.searbtn2 {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  display: inline-block;
  background: #DCDFE6;
  border-radius: 16px;
}

</style>